import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  media;
  enableVideo=false;
  private timeOut;
  //tooglePlay=true;

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    //this.media=document.querySelector('video');
    //console.log(this.media);
    this.startTimeOut();
  }

  start() {
    clearTimeout(this.timeOut);
    this.router.navigate(['contact']);
  }

  playPauseMedia() {
    console.log("playPauseMedia");
    this.media=document.querySelector('video');
  if(this.media.paused) {
    console.log("play");
    this.media.play();
   // this.tooglePlay=true;
  } else {
  //  this.media.pause();
  //  this.tooglePlay=false;
  }
}

  returnToQuiz() {
    this.enableVideo=false;
    this.startTimeOut();
  }

  startTimeOut(){
    console.log('startTimeOut');
    clearTimeout(this.timeOut);
    this.timeOut = setTimeout(()=>{
      this.enableVideo=true;
      //this.playPauseMedia();
    }, 60000);
  }

}
